import { render, staticRenderFns } from "./OrganizationContacts.vue?vue&type=template&id=507d2f92"
import script from "./OrganizationContacts.vue?vue&type=script&lang=js"
export * from "./OrganizationContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports